import {StateContext} from '@ngxs/store';
import {ValidationError} from '../models/validation-error.model';
import {UpdateFormStatus} from '@ngxs/form-plugin';
import {FormStatus} from '../enums/file-status.enum';

export const setFormStatus = (ctx: StateContext<any>, status: FormStatus, stateName: string, attribute = 'form') => {
    return ctx.dispatch(new UpdateFormStatus({status, path: `${stateName}.${attribute}`}));
};

export const setFormValidationErrors = (ctx: StateContext<any>, validationErrors: ValidationError[], stateName, attribute = 'form') => {
    const errors = {};
    validationErrors.forEach(error => {
        if (!Array.isArray(errors[error.field])) {
            errors[error.field] = [];
        }
        errors[error.field].push(error.description || error.code);
    });
    ctx.patchState({
        [attribute]: {
            ...ctx.getState()[attribute],
            status: FormStatus.INVALID,
            validationErrors: errors,
        }
    });
    setFormStatus(ctx, FormStatus.INVALID, stateName, attribute);
};

export const clearFormValidationErrors = (ctx: StateContext<any>, fields: string[] = [], attribute = 'form') => {
    const form = ctx.getState()[attribute];
    let validationErrors = {};
    if (Array.isArray(fields) && fields.length) {
        validationErrors = {...form.validationErrors};
        Object.keys(form.validationErrors).forEach(errorKey => {
            if (fields.some(fieldKey => errorKey.startsWith(fieldKey))) {
                delete validationErrors[errorKey];
            }
        });
    }
    ctx.patchState({
        [attribute]: {
            ...form,
            validationErrors
        }
    });
};

export const DEBOUNCE_TIME = 500;

export const FORM_ERROR_SCROLL_HOOK = 'form-error-scroll-hook';
